
<i class="icon-trash font-small-3 mr-2 danger cursor-pointer"
   [swal]="{
       title: '¿Estas seguro?',
       icon: 'warning',
       showCancelButton: true,
       confirmButtonText: 'Aceptar',
       cancelButtonText: 'Cancelar'
    }"
   (confirm)="deleteAction($event)">
</i>

